import { useState, MouseEvent, ChangeEvent } from "react";
import { ICandidateHistory } from "../../../../App/Typings/CandidateProfile";
import { TableSortOrder } from "../../../../App/Typings/SortableTable";

export function useSortableTableState(tableData: ICandidateHistory[]) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState<TableSortOrder>("asc");
  const [orderBy, setOrderBy] = useState<keyof ICandidateHistory>("dateChanged");

  const handleRequestSort = (event: MouseEvent<unknown>, property: keyof ICandidateHistory) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return {
    getters: {
      page,
      rowsPerPage,
      order,
      orderBy: orderBy.toString(),
    },
    setters: {
      setPage,
      setRowsPerPage,
      setOrder,
      setOrderBy,
    },
    handlers: {
      handleRequestSort,
      handleChangePage,
      handleChangeRowsPerPage,
    },
  };
}
